import React from 'react';
import BlogPostCard from './BlogPostCard';
import BlogPostCardSlider from './BlogPostCardSlider';


const Carousal = (props) => {
    const data = props.item && props.item.text_data &&  props.item.text_data.carousel && props.item.text_data.carousel;
     
    console.log('carousalprops ',props);


    return(
        <BlogPostCardSlider>
       { data &&  data.map( i => (
          <div style={{height:"400px", width:"315px" ,borderRadius:"10px",border:"1px solid #6c757d",marginRight:"20px"}}>
            <a href={!props.disable && i.url} target="_blank" onClick={() => {if(!props.disable){props.handleClick(i.code)}}} > <img src={i.image} style={{width:'100%',height:'80%',backgroundSize:'contain',backgroundRepeat:'no-repeat',borderRadius:'10px'}}/>
           </a> 
           <div className="form-group">
                     <div className="btn-contr" style={{textAlign:'center'}}> 
                         <a  href={!props.disable && i.url} target="_blank" className={!props.disable ?"btn btn-primary waves-effect waves-light":"btn btn-hist waves-effect waves-light histbg"}  onClick={() => {
                             if(!props.disable)
                             {props.handleClick(i.code)}}} style={{fontSize:"15px",marginTop:"20px" }}>UpgradeNow</a> 
                     </div>
                     <div className="height50">&nbsp;</div>
                 </div>
           </div>)) }
           </BlogPostCardSlider>
    )
}


export default Carousal;